import ReactDOM from 'react-dom';

const MenuButtonsPortal: React.FC = ({ children }) => {
  const element = document.getElementById('header-bottom-right-container');
  return element ? ReactDOM.createPortal(children, element) : null;
};

export default MenuButtonsPortal;
